"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.peritext = exports.Peritext = exports.PeritextApi = exports.PeritextNode = void 0;
const tslib_1 = require("tslib");
const constants_1 = require("../constants");
const PeritextNode_1 = require("./PeritextNode");
Object.defineProperty(exports, "PeritextNode", { enumerable: true, get: function () { return PeritextNode_1.PeritextNode; } });
const PeritextApi_1 = require("./PeritextApi");
Object.defineProperty(exports, "PeritextApi", { enumerable: true, get: function () { return PeritextApi_1.PeritextApi; } });
const Peritext_1 = require("./Peritext");
Object.defineProperty(exports, "Peritext", { enumerable: true, get: function () { return Peritext_1.Peritext; } });
const constants_2 = require("./constants");
const Extension_1 = require("../../json-crdt/extensions/Extension");
tslib_1.__exportStar(require("./slice"), exports);
tslib_1.__exportStar(require("./block"), exports);
tslib_1.__exportStar(require("./registry/SliceBehavior"), exports);
tslib_1.__exportStar(require("./registry/SliceRegistry"), exports);
tslib_1.__exportStar(require("./slice/constants"), exports);
tslib_1.__exportStar(require("./events/PeritextEventTarget"), exports);
tslib_1.__exportStar(require("./events/defaults/PeritextEventDefaults"), exports);
tslib_1.__exportStar(require("./PeritextHeadless"), exports);
exports.peritext = new Extension_1.Extension(constants_1.ExtensionId.peritext, constants_2.MNEMONIC, PeritextNode_1.PeritextNode, PeritextApi_1.PeritextApi, (text) => (0, constants_2.SCHEMA)(text));
